(function () {
    "use strict";
    angular.module('app').directive('otherRemark', OtherRemarkDirective);

    OtherRemarkDirective.$inject = ['webApiServices', 'notificationService'];
    function OtherRemarkDirective(webApiServices, notificationService) {
        return {
            transclude: true,
            // eslint-disable-next-line angular/no-directive-replace
            replace: true,
            scope: {
                allRemarks: '=',
                remarkName: '@',
                requestPublicId: '@',
                sectionType: '@',
                buttonText: '@',
                buttonRemoveText: '@',
                description: '@',
                formRequired: '@'
            },
            template: `
                    <div class="tab-panel">
                        <div class="row">
                            <button type="button" ng-if="!remark.Remark && !remarkAdded" class="btn pull-left" ng-click="AddRemoveRemark()">
                                <i class="fa fa-plus"></i> {{ buttonText }}
                            </button>
                        </div>
                        <div ng-if="remark.Remark || remarkAdded">
                            <div class="row">
                                <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
                                    <label>{{ description }}<label>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3" ng-if="remark.Remark || remarkAdded">
                                    <button type="button" class="btn btn-danger pull-right " ng-click="AddRemoveRemark()">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="row space-above">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <textarea
                                        aria-describedby="{{remarkName}}Error"
                                        class="form-control "
                                        id="{{remarkName}}"
                                        name="{{remarkName}}"
                                        ng-model="remark.Remark"
                                        rows="4"
                                        ng-required="true"
                                        type="text" value="" required="required"
                                        ng-blur="AddOrUpdateRemark()">
                                    </textarea>
                                    <div style="color:red" ng-if="remarkAdded && !remark.Remark">
                                        <div style="border-top: 3px solid red">
                                            {{ formRequired }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    `,
            link: function ($scope) {
                if (!$scope.allRemarks && !$scope.remarkName)
                    return false;
                $scope.remarkAdded = false;
                $scope.remark = _.find($scope.allRemarks, { SectionName: $scope.remarkName });
                if ($scope.remark && $scope.remark.Remark) $scope.remarkAdded = true;
                $scope.remarkIndex = _.findIndex($scope.allRemarks, $scope.remark);

                $scope.AddRemoveRemark = function () {
                    $scope.remark.Remark = null;
                    $scope.remarkAdded = !$scope.remarkAdded;

                    $scope.AddOrUpdateRemark();
                };

                $scope.AddOrUpdateRemark = function () {
                    if (!$scope.allRemarks || !$scope.remarkName || !$scope.sectionType || !$scope.requestPublicId)
                        return;

                    const createUpdatePayload = {
                        RequestId: $scope.requestPublicId,
                        Remark: {
                            PublicId: $scope.remark.PublicId,
                            Deleted: !$scope.remarkAdded,
                            ValidCode: $scope.sectionType,
                            InValidCode: $scope.sectionType,
                            Section: $scope.sectionType,
                            Description: $scope.remark.Remark
                        }
                    };

                    webApiServices.SaveRequestRemark(
                        createUpdatePayload,
                        angular.noop,
                        (error) => DoShowError(notificationService, error)
                    );

                    $scope.allRemarks[$scope.remarkIndex].Remark = $scope.remark.Remark;
                };
            }
        };
    }
})();